module.exports = __webpack_public_path__ + "a72fd7991a95d0bcd13697b24fae8649.png";